import { Component, computed, effect, ElementRef, inject, OnInit, signal, viewChild } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { DataService } from '../../../services/data.service';
import { ThemeService } from '../../../services/theme.service';
import { VenueType } from '../../../shared/enums';

@Component({
  selector: 'app-menu-home',
  templateUrl: './menu-home.component.html',
  styleUrl: './menu-home.component.scss',
  standalone: false,
})
export class MenuHomeComponent implements OnInit {
  logoUrl = computed(() => {
    const url = this.dataService.restaurant().logo_url;
    return url
      ? this.sanitizer.bypassSecurityTrustStyle(`url('${url}')`)
      : null;
  });
  isGridLayout = computed(() => this.dataService.isGridLayout());
  isSearching = signal(false);
  currentTable = computed(() => this.dataService.table());
  title = computed(() => {
    const table = this.currentTable();
    const isReadOnlyVenue = this.dataService.restaurant()?.type === VenueType.ReadOnly;
    return (isReadOnlyVenue ? table?.name : [table?.table_type, table?.name].filter(Boolean).join(' ')) ?? '';
  });
  showHomeBtn = computed(() => this.dataService.hasLandingPage);

  private themeService = inject(ThemeService);
  //Dukley theme - menu bar on the home page
  showBottomBar = computed(() => this.themeService.currentTheme() === 'dukley');

  // Real height of the top-bar + combo guide block together, so the grid layout's
  // own sticky cart preview offsets against what's actually on screen instead of a
  // fixed guess - the guide block's height changes with how many combos are active.
  private stickyHeaderEl = viewChild<ElementRef<HTMLDivElement>>('stickyHeader');
  headerHeight = signal(40);

  pageMinHeight = computed(() =>
    this.isSearching() ? '100dvh' : `calc(100dvh - ${this.headerHeight()}px)`
  );

  constructor(
    private dataService: DataService,
    private sanitizer: DomSanitizer,
  ) {
    effect((onCleanup) => {
      const el = this.stickyHeaderEl()?.nativeElement;
      if (!el) return;

      const observer = new ResizeObserver(() => this.headerHeight.set(el.offsetHeight));
      observer.observe(el);
      this.headerHeight.set(el.offsetHeight);
      onCleanup(() => observer.disconnect());
    });
  }

  ngOnInit(): void {
  }

}
